<script setup lang="ts">
import { computed } from "vue"
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'

const props = defineProps<{
  row: QuoteSummary
}>()

const showNewIndicator = computed(() => {
  const { seenByClient, expirationDatetime } = props.row
  const hasBeenSeen = !!seenByClient
  if (hasBeenSeen) {
    return false
  }

  if (!expirationDatetime) {
    return false
  }
  return !isExpiredV2(expirationDatetime)
})
</script>

<template>
  <div class="d-flex align-center">
    <div
      v-if="showNewIndicator"
      class="w-8 h-8 background-primary margin-l-n4 margin-r-2 border-radius-round"
    />
    {{ row.id }}
  </div>
</template>
